// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 354 ? "31a19646" : chunkId) + "." + {"354":"8b411813c46a84aa","604":"e59ddcd21c36d787"}[chunkId] + ".js";
};